module.exports = __webpack_public_path__ + "static/media/Future clinic trials provide digital healthcare through telemedicine software.a545b409.webp";